module.exports = __webpack_public_path__ + "static/img/act01.6ebea32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/act01.jpg
// module id = 6qIb
// module chunks = 1